import type { FC } from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const PayByCheckIcon: FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.66671 7.83398H4.00004C1.79382 7.83398 1.33337 8.29445 1.33337 10.5007V12.5007C1.33337 14.7069 1.79382 15.1673 4.00004 15.1673H12C14.2062 15.1673 14.6667 14.7069 14.6667 12.5007V10.5007C14.6667 9.02658 14.4612 8.33185 13.6667 8.03312"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 12.5H12"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4961 2.58926C11.7942 2.26584 11.9432 2.10413 12.1016 2.00981C12.4837 1.78221 12.9543 1.77514 13.3428 1.99114C13.5038 2.08066 13.6574 2.23782 13.9646 2.55212C14.2719 2.86644 14.4255 3.02359 14.513 3.18831C14.7242 3.58576 14.7172 4.06712 14.4948 4.45806C14.4026 4.62007 14.2445 4.77254 13.9284 5.07747L10.1669 8.70565C9.17036 9.66685 8.5531 9.86618 7.17276 9.83005C6.92216 9.82345 6.7969 9.82018 6.7241 9.73738C6.65123 9.65465 6.66118 9.52685 6.68103 9.27118C6.77276 8.09272 6.98036 7.48892 7.78243 6.61869L11.4961 2.58926Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);
